import { t2v, videoModel } from "./defaults";

export const minimaxH3 = videoModel("minimax-h3", "MiniMax H3", { start: 1 }, t2v("minimax/h3/text-to-video"));
